export default __webpack_public_path__ + "static/crocrow-71182cb5646d213f1282e9c704c679e0.jpg";